import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Quote_Start from "../assets/quote_start.svg";
import Avatar from "../assets/avatar.png";

const muiTheme = createTheme({
    palette: {
        custom: {
            main: '#FFF'
        },
    },
    components: {
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: "#009BB5",
                }
            }
        }
    }
});

const useStyles = theme => ({
    panel: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        background: '#0E8064',
    },
    content: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        flexDirection: 'column',
        padding: '40px 28px',

        [theme.breakpoints.up('md')]: {
            width: '770px',
            flexDirection: 'row',
        }
    },
    icon: {
        padding: '0 0 15px 0',

        [theme.breakpoints.up('md')]: {
            padding: '10px 15px 0 0',
        }
    },
    title: {
        fontFamily: 'Young Serif',
        fontSize: '2.6em',
        lineHeight: '1.1em',
    },
    host: {
        padding: '15px 0',
        fontFamily: 'Montserrat',
        fontSize: '1.1em',
        fontWeight: 'bold',
        lineHeight: '1.4em',
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
    },
    description: {
        fontFamily: 'Montserrat',
        fontSize: '1.4em',
        lineHeight: '1.4em',
    },
    listen: {
        padding: '20px 0',
        fontFamily: 'Montserrat',
        fontSize: '1.1em',
        fontWeight: 'bold',
        lineHeight: '1.4em',

        '& a': {
            color: 'inherit',
            textDecoration: 'underline',
        },

        '& a:hover': {
            color: 'inherit',
            textDecoration: 'none',
        },
    },
    logo: {
        [theme.breakpoints.up('md')]: {
            padding: '60px 0 0 30px',
        }
    }
});

class AboutPanel extends React.PureComponent {
    render() {
        const { classes } = this.props;

        return (
            <ThemeProvider theme={muiTheme}>

                <div className={classes.panel}>
                    <div className={classes.content}>

                        <div className={classes.icon}><img src={Quote_Start} alt={"Quote"} /></div>

                        <div className={classes.podcastContent}>
                            <div className={classes.title}>Experiences, that's what life's about to me</div>
                            <div className={classes.host}>Matt Allbeury, Founder and Trainer</div>
                            <div className={classes.description}>
                            Looking up at a snow capped mountain, filling the running pack with survival gear, then several hours later reaching the summit. Looking out across a bay, entering the surf and swimming out to sea..
                            <br/><br/>
                            Not always this way, having chronic asthma as a kid defined me, a light jog would often start the wheezing, swimming was my worst fear.
                            <br/><br/>
                            My takeaway, don't let anything or anyone define you. My life is devoted to challenging myself and I thrive on helping others do the same - unlocking potential and the power of progress.
                            </div>
                            <div className={classes.listen}><a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/matt-allbeury/">Connect on LinkedIn</a></div>
                        </div>

                        <div className={classes.logo}><a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/matt-allbeury/"><img src={Avatar} alt={"Avatar"} /></a></div>

                    </div>
                </div>

            </ThemeProvider>
        )
    }
}

export default withStyles(useStyles)(AboutPanel)